// socket.js
import { io } from "socket.io-client";

const getToken = () => localStorage.getItem('user_token');

const socket = io(`${process.env.REACT_APP_SOCKET_URL}`, {
    path:"/api/socket.io",
    extraHeaders: {
        authorization: getToken() || ""
    },
    autoConnect: false,
    withCredentials: true
});

export const connectSocket = () => {
    socket.io.opts.extraHeaders = {
        authorization: getToken() || ""
    };
    socket.connect();
};

export default socket;
